import { render } from "./SelectedOrder.vue?vue&type=template&id=7b1f6618&scoped=true"
import script from "./SelectedOrder.vue?vue&type=script&lang=js"
export * from "./SelectedOrder.vue?vue&type=script&lang=js"

import "./SelectedOrder.vue?vue&type=style&index=0&id=7b1f6618&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1f6618"]])

export default __exports__